module.exports = __webpack_public_path__ + "img/oddbot.8a45296d.png";